import React from 'react';
import { motion } from 'framer-motion';
import { type BadgeSlotModel } from '../../../utils/adventurePresentation';

interface BadgeSlotProps {
  badge: BadgeSlotModel;
  testId?: string;
}

export const BadgeSlot: React.FC<BadgeSlotProps> = ({ badge, testId }) => (
  <motion.div
    data-testid={testId}
    whileHover={{ y: -2, scale: 1.04 }}
    className={`group relative flex h-12 w-12 items-center justify-center rounded-2xl border shadow-sm transition ${
      badge.unlocked
        ? 'border-amber-200 bg-[radial-gradient(circle_at_top,#fff7c2,#ffffff_72%)]'
        : 'border-slate-200 bg-slate-100'
    }`}
    title={`${badge.name} · ${badge.hint}`}
  >
    {badge.unlocked && (
      <span className="absolute inset-0 rounded-2xl bg-amber-200/50 blur-md" aria-hidden="true" />
    )}
    <img
      src={badge.icon}
      alt=""
      aria-hidden="true"
      data-testid={testId ? `${testId}-icon-${badge.id}` : `badge-icon-${badge.id}`}
      className={`relative h-6 w-6 object-contain ${badge.unlocked ? '' : 'opacity-40 grayscale'}`}
    />
  </motion.div>
);
